const Sizes = {
   ButtonHeight: 40,
   InputHeight: 40,
   ButtonMedium: 50,
   ButtonLarge: 90,
};

export default Sizes;
